const VALID_APPEARANCES = ['default', 'success', 'removed', 'inprogress', 'new', 'moved'];
export const isValidAppearance = appearance => {
  return VALID_APPEARANCES.indexOf(appearance) !== -1;
};
export const VALID_STATES = {
  open: 'inprogress',
  merged: 'success',
  declined: 'removed',
  closed: 'success',
  draft: 'inprogress',
  archived: 'default'
};
export const OMIT_STATES = ['current'];